import { render } from "./LastTransactions.vue?vue&type=template&id=fedecabe&scoped=true"
import script from "./LastTransactions.vue?vue&type=script&lang=js"
export * from "./LastTransactions.vue?vue&type=script&lang=js"

import "./LastTransactions.vue?vue&type=style&index=0&id=fedecabe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fedecabe"]])

export default __exports__